import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';

interface RoleRouteProps {
  children: React.ReactNode;
  path: string;
}

export default function RoleRoute({ children, path }: RoleRouteProps) {
  const { currentUser } = useAuth();
  const [hasAccess, setHasAccess] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAccess = async () => {
      if (!currentUser) {
        setHasAccess(false);
        return;
      }

      // Admin tem acesso a tudo
      if (currentUser.role === 'admin') {
        setHasAccess(true);
        return;
      }

      // Verifica as permissões do role do usuário
      const roleDoc = await getDoc(doc(db, 'roles', currentUser.role));
      if (!roleDoc.exists()) {
        setHasAccess(false);
        return;
      }

      const menuAccess = roleDoc.data().menuAccess || [];
      setHasAccess(menuAccess.includes(path));
    };

    checkAccess();
  }, [currentUser, path]);

  if (hasAccess === null) {
    return <div>Loading...</div>;
  }

  if (!currentUser || !hasAccess) {
    return <Navigate to="/" />;
  }

  return <>{children}</>;
}
